import chunk from 'lodash/chunk'

import FieldsCollection from 'modules/custom_resources/store/collections/customResources/fields'
import resources from 'modules/custom_resources/store/collections/customResources/resources'
import schemas from 'modules/custom_resources/store/collections/customResources/schemas'
import values from 'modules/custom_resources/store/collections/customResources/values'

const MAX_BATCH_SIZE = 250

interface Props {
  topicNames: string[]
  attachableType: string
  attachableId: number
}

const fetchData = async ({ topicNames, attachableType, attachableId }: Props) => {
  await schemas.fetch({
    data: {
      topic_names: topicNames,
    },
    remove: false,
  })

  const filteredSchemas = schemas.filter((f) => topicNames.includes(f.get('topic')))

  const schemaIds = filteredSchemas.map((s) => s.attributes.id)
  const fields = new FieldsCollection()

  if (schemaIds.length > 0) {
    await fields.fetch({
      data: {
        schema_ids: schemaIds,
      },
    })
    await resources.fetch({
      data: {
        attachable_type: attachableType,
        attachable_id: attachableId,
        schema_ids: schemaIds,
      },
    })

    const resourceIds: number[] = resources.map((r) => r.attributes.id)
    const batches = chunk(resourceIds, MAX_BATCH_SIZE)

    if (resourceIds.length > 0) {
      for (let i = 0; i < batches.length; i++) {
        await values.fetch({
          data: {
            resource_ids: batches[i],
          },
          remove: false,
        })
      }
    }
  }

  return {
    schemas: filteredSchemas,
    fields: fields.models,
    resources: resources.models,
    values: values.models,
  }
}

export default fetchData
